import { Button, Form, Input, Space } from 'antd';
import { FC } from 'react';

import { ButtonSuccess } from '../../../../../common/components';
import { AppFormProps } from '../../../../../common/interfaces';
import { defineInputStatus } from '../../../../../common/utils';
import { RobotsFormFields, RobotsFormInputs } from '../../../robots.interfaces';

interface Props extends AppFormProps<typeof RobotsFormInputs, RobotsFormFields> {
}

export const RobotsFormView: FC<Props> = ({
  formName,
  formType,
  form,
  initialValues,
  isFormLoading,
  formErrors,
  validationSchema,
  handleBack,
  handleFinish,
  handleFinishFailed
}) => {
  return (
    <Form
      form={ form }
      name={ formName }
      disabled={ isFormLoading }
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      initialValues={ initialValues }
      autoComplete="off"
      onFinish={ handleFinish }
      onFinishFailed={ handleFinishFailed }
    >
      <Form.Item
        label="Вміст"
        name={ RobotsFormInputs.Content }
        hasFeedback
        required={ false }
        help={ formErrors?.content }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.content) }
        rules={ validationSchema.content }
      >
        <Input.TextArea
          allowClear autoSize={{ maxRows: 20, minRows: 10 }} count={{
            show: ({ count }) => `рядків: ${ count }`,
            strategy: (txt) => txt ? txt.split('\n').length : 0
          }}/>
      </Form.Item>

      <Form.Item wrapperCol={{ span: 24 }}>
        <Space align="center" style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button type="default" onClick={ handleBack }>
            Скасувати
          </Button>
          <ButtonSuccess loading={ isFormLoading } type="primary" htmlType="submit">
            { formType === 'edit' ? 'Зберегти' : 'Створити' }
          </ButtonSuccess>
        </Space>
      </Form.Item>
    </Form>
  );
};
